import type { PersonStats } from '~/lib/api/types'
import styles from './hours-summary.module.scss'

type Props = { stats: PersonStats }

export function HoursSummary({ stats }: Props) {
  return (
    <div className={styles.grid} role="group" aria-label="Engineer summary">
      <Stat label="avg hours" value={fmtHours(stats.avg_hours)} />
      <Stat label="median" value={fmtHours(stats.median_hours)} />
      <Stat label="min" value={fmtHours(stats.min_hours)} />
      <Stat label="max" value={fmtHours(stats.max_hours)} />
      <Stat label="active" value={String(stats.active_days)} />
      <Stat label="missing" value={String(stats.missing_days)} />
      <Stat label="ooo" value={String(stats.ooo_days)} />
      <Stat label="streak" value={String(stats.current_streak)} />
    </div>
  )
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div className={styles.stat}>
      <p className={`${styles.value} mono`}>{value}</p>
      <p className={styles.label}>{label}</p>
    </div>
  )
}

function fmtHours(n: number | null): string {
  if (n == null) return '—'
  return `${n}h`
}
